import { supabase } from './supabaseClient';

// Sign up function — only handles auth, does NOT insert into `users`
export const signUp = async (email, password, metadata) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: metadata,
    },
  });

  if (error) throw error;

  return data;
};


export const logIn = async (email, password) => {
  // 1. Authenticate with Supabase Auth
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) throw error;

  const user = data.user;

  // 2. Fetch user details (Role & Confirmed status) from profile_table
  // We fetch everything (*) so we can check 'confirmed' and 'role' at the same time.
  const { data: profileData, error: fetchError } = await supabase
    .from('profile_table')
    .select('*')
    .eq('id', user.id)
    .single();

  if (fetchError) {
    console.error('Error fetching profile:', fetchError);
  }

  const userProfile = profileData || {};

  // 3. Update 'confirmed' status if the Auth email is verified but DB says false
  const isEmailVerified = user.email_confirmed_at !== null || user.confirmed_at !== null;

  if (userProfile && !userProfile.confirmed && isEmailVerified) {
    const { error: updateError } = await supabase
      .from('profile_table')
      .update({
        confirmed: true,
        updated_at: new Date(),
      })
      .eq('id', user.id);

    if (updateError) {
      console.error('Failed to update confirmed status:', updateError);
    } else {
      console.log('✅ Confirmed status synced to profile_table');
    }
  }

  // 4. Fetch role and role_permissions if user has row_id (role assigned)
  let roleData = null;
  if (userProfile && userProfile.row_id) {
    const { data: fetchedRole, error: roleError } = await supabase
      .from('role_table')
      .select('id, role_name, role_permissions')
      .eq('id', userProfile.row_id)
      .single();

    if (roleError) {
      console.error('Error fetching role details:', roleError);
    } else {
      roleData = fetchedRole;
    }
  }

  // 5. Store Role info in LocalStorage
  // Default to 'user' if the role is missing
  const role = roleData?.role_name || 'user';
  const rolePermissions = roleData?.role_permissions || [];
  
  localStorage.setItem('userRole', role);
  localStorage.setItem('userPermissions', JSON.stringify(rolePermissions));

  
  // 6. Return data with role details
  return { 
    user, 
    role, 
    rolePermissions,
    roleId: userProfile?.row_id,
    profile: userProfile,
    roleData 
  };
};

// Google Sign-In
export const signInWithGoogle = async () => {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
  });

  if (error) throw error;
};
